import React,{ useState } from "react"
import { makeStyles, TextField } from "@material-ui/core";
import CopyToClipboard from "react-copy-to-clipboard";
import {ReactComponent as CopySVG} from "../../../assets/images/icon-copy.svg"
import { useTranslation } from "react-i18next";
import ICommonFormProps from "../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import FormElement from "../../../yoello-lib/modules/dynamicForms/FormElement";
import { generateRegister } from "../../../yoello-lib/modules/dynamicForms/utils";

interface IMenuURLLookup extends ICommonFormProps {
  Component: React.FunctionComponent<any>;
  label: string
}

const useStyles = makeStyles({
  root: {
    display:"flex",
    alignItems:"end"
  },
  label: {
    width: "100%",
    display:"flex",
    flexDirection:"column"
  },
  labelText: {
    color: "#626262",
    fontSize: "0.875rem",
    lineHeight: "2rem",
  },
  button:{
    marginLeft:"0.625rem",
    background: "#FAF6E0",
    border: "1.5px solid #FFDD02",
    borderRadius: "10px",
    padding:"0.8125rem 1.25rem !important",
    height:"3rem!important",
    display:"flex",
    alignItems:"center",
    backgroundPosition: "center",
    transition: "background 0.8s",
    "&>svg":{
        marginRight:"0.625rem",
        height:"16px",
        width:"22px"
    },
    cursor:"pointer",
  }
});

export  function MenuURLLookup(props:IMenuURLLookup) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [copied, setCopied] = useState(false);
  const { keyName, label } = props;
  return (
    <div className={classes.root}>
      <label className={classes.label}>
        <span className={classes.labelText}>{label}</span>
        <FormElement {...props} keyName={keyName}>
          <TextField
            name={keyName}
            variant="outlined"
            disabled={true}
            value={props?.formProps?.menuURL}
            {...generateRegister(props)}
            type={"text"}
          />
        </FormElement>
      </label>
      <CopyToClipboard text={props?.formProps?.menuURL} onCopy={() => setCopied(true)}>
            <div
              className={classes.button}
            >
              <CopySVG/>
              <span>
                 {t(`qrCode.${copied ? "copied" : "copy"}`)}
              </span>
            </div>
      </CopyToClipboard>
    </div>
  )
}
